export default class AdmCmsMember {
  orgMember


  constructor(responseItem) {
    this.orgMember = responseItem
  }

  getNewMember(rentalcompanyId) {
    return {
      isNew: true,
      /**
       * 업체 아이디
       */
      rentalcompanyId: rentalcompanyId,

      memberId: undefined,

      /**
       * CMS 서비스 제공 업체(효성/나이스)
       */
      serviceProvider: 'N',

      /**
       * 납부자 이메일
       */
      email: undefined,

      /**
       * 비고
       */
      memo: undefined,

      /**
       * sms 사용여부
       */
      smsYn: 'Y',

      /**
       * 납부자 타입.
       * 개인(I)
       * 사업자(B)
       */
      payerType: 'I',

      /**
       * 결제 방법 (은행/카드)
       */
      paymentKind: 'B',

      /**
       * 은행 코드. 카드는 사용하지 않음.
       */
      bankCode: null,

      /**
       * 결제 번호 (계좌번호/카드번호)
       */
      paymentNumber: undefined,

      /**
       * 예금주 이름
       */
      payerName: undefined,

      /**
       * 사업자 : 사업자번호
       * 개인 : 생년월일
       */
      payerNumber: undefined,

      /**
       * 예금주 연락처
       */
      payerPhone: undefined,

      /**
       * 일시 정지 여부.
       * MPS 서비스에서 CMS 처리만 하지 않습니다.
       * 실제로 CMS 서비스 업체에 일시정지를 요청하지 않습니다.
       */
      temporarySuspension: false,

      /**
       * 일시 정지 여부
       * MPS 서비스에서만 사용이므로 acctPause 만 control 한다.
       */
      acctPause: 'N',

      /**
       * 현금영수증 발행 여부.
       */
      cashReceiptIssue: 'N',

      /**
       * 현금영수증 번호.
       */
      cashReceiptNumber: undefined,

      /**
       * 카드 유효 기간.
       */
      cardValidDate: undefined,

      /**
       *  cmsMemberId tb_cms_member table의 기본키로 하나의 거래처의 다중 cms 등록을 할 수 있기때문에 P.K를 구분자로 한다
       */
      cmsMemberId: undefined,

      /**
       * cms 회원의 cms업체간 사용할 cmsId 를 front에서 직접받아준다 - 기등록 고객의 cms data이관을 위해 추가 됨. 2021-05-19 반영예정.
       */
      cmsId: undefined,

      /**
       * cms 효성 카드 일 경우 공휴일 출금 신청 여부
       */
      cardHolidayYn: 'Y',

      /**
       * cms 회원 다중 처리로 인한 cms별 별명
       */
      nickname: undefined,
      autoYn: 'N',
      cardReceiptYn: 'N',
      simpleYn: 'N',
      agreementSimpleId: undefined,
      agreementStatusYn: undefined,
      agreeFile: null,
      fileOrgName: undefined,
      procType: undefined,
      resultYn: undefined,
      resultMsg: undefined,
    }
  }

  getConvertMember() {
    return {
      isNew: false,
      /**
       * 업체 아이디
       */
      rentalcompanyId: this.orgMember.rentalcompanyId,

      memberId: this.orgMember.memberId,

      /**
       * CMS 서비스 제공 업체(효성/나이스)
       */
      serviceProvider: this.orgMember.cmsType,

      /**
       * 납부자 이메일
       */
      email: this.orgMember.csEmail,

      /**
       * 비고
       */
      memo: this.orgMember.memo,

      /**
       * sms 사용여부
       */
      smsYn: this.orgMember.smsYn || 'N',

      /**
       * 납부자 타입.
       * 개인(I)
       * 사업자(B)
       */
      payerType: this.orgMember.payerType,

      /**
       * 결제 방법 (은행/카드)
       */
      paymentKind: this.orgMember.payMethod,

      /**
       * 은행 코드. 카드는 사용하지 않음.
       */
      bankCode: this.orgMember.bankCd,

      /**
       * 결제 번호 (계좌번호/카드번호)
       */
      paymentNumber: this.orgMember.accNo || this.orgMember.cardNo,

      /**
       * 예금주 이름
       */
      payerName: this.orgMember.accHolder,

      /**
       * 사업자 : 사업자번호
       * 개인 : 생년월일
       */
      payerNumber: this.orgMember.accBizNo,

      /**
       * 예금주 연락처
       */
      payerPhone: this.orgMember.csHp,

      /**
       * 일시 정지 여부.
       * MPS 서비스에서 CMS 처리만 하지 않습니다.
       * 실제로 CMS 서비스 업체에 일시정지를 요청하지 않습니다.
       */
      temporarySuspension: false,

      /**
       * 일시 정지 여부
       * MPS 서비스에서만 사용이므로 acctPause 만 control 한다.
       */
      acctPause: this.orgMember.acctPause,

      /**
       * 현금영수증 발행 여부.
       */
      cashReceiptIssue: this.orgMember.cashReceiptType,

      /**
       * 현금영수증 번호.
       */
      cashReceiptNumber: this.orgMember.cashReceiptNo,

      /**
       * 카드 유효 기간.
       */
      cardValidDate: this.orgMember.cardValidDt,

      /**
       *  cmsMemberId tb_cms_member table의 기본키로 하나의 거래처의 다중 cms 등록을 할 수 있기때문에 P.K를 구분자로 한다
       */
      cmsMemberId: this.orgMember.id,

      /**
       * cms 회원의 cms업체간 사용할 cmsId 를 front에서 직접받아준다 - 기등록 고객의 cms data이관을 위해 추가 됨. 2021-05-19 반영예정.
       */
      cmsId: this.orgMember.cmsId,

      /**
       * cms 효성 카드 일 경우 공휴일 출금 신청 여부
       */
      cardHolidayYn: 'N',

      /**
       * cms 회원 다중 처리로 인한 cms별 별명
       */
      nickname: this.orgMember.nickname,
      autoYn: this.orgMember.autoYn ,
      cardReceiptYn: this.orgMember.cardReceiptYn ,
      simpleYn: this.orgMember.simpleYn,
      agreementSimpleId: undefined,
      agreementStatusYn: undefined,
      agreeFile: null,
      fileOrgName: this.orgMember.fileOrgName || undefined,
      procType: this.orgMember.procType,
      resultYn: this.orgMember.resultYn,
      resultMsg: this.orgMember.resultMsg,
    }
  }
}